<template>
  <div v-if="getProfileDashboardDesc" class="mt-16 card" id="div_profilDesc">
    <h2 id="div_profilDescHeadline">
      {{ getProfileDashboardTitle }}
    </h2>
    <h3 class="mt-8" id="txt_greatestStrengths">
      {{ $t('DashboardProfileComponent.yourDimensions') }}
    </h3>
    <div class="block p-5">
      <h2 class="pb-2 text-[var(--color-orange)]" id="txt_strength1">
        {{ getProfileDashboardDesc.first?.headline?.[this.locale] ?? '' }}
      </h2>
      <p id="txt_strength1Desc">
        {{ getProfileDashboardDesc.first?.text[this.locale] ?? '' }}
      </p>
    </div>
    <div class="block p-5">
              <h2 class="pb-2 text-[var(--color-orange)]" id="txt_strength2">
        {{ getProfileDashboardDesc.behindFirst?.headline?.[this.locale] ?? '' }}
      </h2>
      <p id="txt_strength2Desc">
        {{ getProfileDashboardDesc.behindFirst?.text[this.locale] ?? '' }}
      </p>
    </div>
    <h3 class="mt-8" id="txt_growthAreas">
      {{ $t('DashboardProfileComponent.youImprove') }}
    </h3>
    <div class="flex flex-wrap justify-around p-5 gap-8">
      <div class="block flex-1">
        <h2 class="pb-2 text-[var(--color-disabled)]" id="txt_growthArea1">
          {{ getProfileDashboardDesc.last?.headline?.[this.locale] ?? '' }}
        </h2>
        <p id="txt_growthArea1Desc">
          {{ getProfileDashboardDesc.last?.text[this.locale] ?? '' }}
        </p>
      </div>
      <div class="block mx-auto flex-1 text-white p-5 bg-[var(--color-orange)] rounded-lg">
        <div class="flex items-center">
          <img src="@/assets/lamp.png" alt="" class="w-12 h-12 mr-5">
          <h3 id="txt_devTip1">
            {{ $t('DashboardProfileComponent.developmentTip') }}
          </h3>
        </div>
        <div class="tip_content">
          <p id="txt_devTip1content">
            {{ getProfileDashboardDesc.last?.tip[this.locale] ?? '' }}
          </p>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap justify-around p-5 gap-8">
      <div class="block flex-1">
        <h2 class="pb-2 text-[var(--color-disabled)]" id="txt_growthArea2">
          {{ getProfileDashboardDesc.beforeLast?.headline?.[this.locale] ?? '' }}
        </h2>
        <p id="txt_growthArea2Desc">
          {{ getProfileDashboardDesc.beforeLast?.text[this.locale] ?? '' }}
        </p>
      </div>
      <div class="block mx-auto flex-1 text-white p-5 bg-[var(--color-orange)] rounded-lg">
        <div class="flex items-center">
          <img src="@/assets/lamp.png" alt="" class="w-12 h-12 mr-5">
          <h3 id="txt_devTip2">
            {{ $t('DashboardProfileComponent.developmentTip') }}
          </h3>
        </div>
        <div class="tip_content">
          <p id="txt_devTip2content">
            {{ getProfileDashboardDesc.beforeLast?.tip[this.locale] ?? '' }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardProfileComponent',
  data() {
    return {
      profileDashboardDesc: this.$store.state.content.profileDashboardDesc,
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    getProfileDashboardDesc() {
      return this.$store.getters.getProfileDashboardDesc;
    },
    getRightSelection() {
      return this.$store.state.dashboard.rightSelected;
    },
    getProfileDashboardTitle() {
      if (this.getRightSelection?.type === 'mindset360') {
        return this.$t('DashboardProfileComponent.yourMindset360InWords');
      }
      return this.$t('DashboardProfileComponent.yourMindsetInWords');
    },
  },
  async mounted() {
    await this.$store.dispatch('getDashboardProfileDescription', 'mindset');
  },
};
</script>
